type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const ImagesIcon = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      {...svgProps}
    >
      <path
        d="M4.50146 8C5.32989 8 6.00146 7.32843 6.00146 6.5C6.00146 5.67157 5.32989 5 4.50146 5C3.67304 5 3.00146 5.67157 3.00146 6.5C3.00146 7.32843 3.67304 8 4.50146 8Z"
        fill={iconColor || '#131313'}
      />
      <path
        d="M14.0015 12C14.0015 13.1046 13.106 14 12.0015 14H2.00146C0.896895 14 0.00146484 13.1046 0.00146484 12V4C0.00146484 2.89594 0.896063 2.00083 1.99992 2C1.99992 0.895431 2.89535 0 3.99992 0H13.9999C15.1045 0 15.9999 0.895431 15.9999 2V10C15.9999 11.1041 15.1053 11.9992 14.0015 12ZM13.9999 1H3.99992C3.44764 1 2.99992 1.44772 2.99992 2L12.0015 2C13.106 2 14.0015 2.89543 14.0015 4V11C14.553 10.9992 14.9999 10.5518 14.9999 10V2C14.9999 1.44772 14.5522 1 13.9999 1ZM2.00146 3C1.44918 3 1.00146 3.44772 1.00146 4V12L3.64791 9.64646C3.81644 9.47793 4.0805 9.45178 4.27882 9.58399L6.93776 11.3566L10.6479 7.64646C10.8001 7.49428 11.0326 7.45655 11.2251 7.5528L13.0015 9.50001V4C13.0015 3.44772 12.5537 3 12.0015 3H2.00146Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
